export enum Role {
  ADMIN = 'admin',
  INSTALLER = 'installer',
  OPERATOR = 'operator',
  VIEWER = 'viewer',
}

export enum FeatureName {
  // Customer
  DELETE_CUSTOMER = 'DeleteCustomer',
  VIEW_AUDIT_HISTORY = 'ViewListAuditHistory',
  VIEW_EDIT_CUSTOMER_PAGE = 'ViewEditCustomerPage',
  VIEW_LIST_CUSTOMERS_PAGE = 'ViewListCustomersPage',
  VIEW_LIST_USERS_PAGE = 'ViewListUsersPage',

  // Device
  ASSIGN_USERS_TO_DEVICE = 'AssignUsersToDevice',
  CREATE_DEVICES = 'CreateDevices',
  CREATE_UPDATE_API_KEYS = 'CreateUpdateApiKeys',
  CREATE_UPDATE_ROI = 'CreateUpdateRoi',
  DELETE_DEVICE = 'DeleteDevice',
  UPDATE_DEVICE = 'UpdateDevice',
  UPDATE_DEVICE_DISABLED_STATUS = 'UpdateDeviceDisabledStatus',
  UPDATE_DEVICE_INSTALL_STATUS = 'UpdateDeviceInstallStatus',
  UPDATE_DEVICE_PRODUCTION_STATUS = 'UpdateDeviceProductionStatus',
  VIEW_API_KEYS = 'ViewApiKeys',
  VIEW_ASSIGNED_USERS = 'ViewAssignedUsers',
  VIEW_DEVICE_CONFIG = 'ViewDeviceConfig',
  VIEW_DEVICES_GRID_MODE = 'ViewDevicesGridMode',
  VIEW_EDIT_DEVICE_PAGE = 'ViewEditDevicePage',
  VIEW_GRAFANA_BUTTON = 'ViewGrafanaButton',
  VIEW_LIST_DEVICES_PAGE = 'ViewListDevicesPage',
  VIEW_ROI_ZONE = 'ViewRoiZone',
  VIEW_DEVICE_COMPARE_PAGE = 'ViewDeviceComparePage',

  // Site
  ASSIGN_DEVICES_TO_SITE = 'AssignDevicesToSite',
  CREATE_SITE = 'CreateSite',
  CREATE_UPDATE_SITE_LOCATION = 'CreateUpdateSiteLocation',
  DELETE_SITE = 'DeleteSite',
  UPDATE_SITE = 'UpdateSite',
  VIEW_EDIT_SITE_METADATA = 'ViewEditSiteMetadata',
  VIEW_EDIT_SITE_PAGE = 'ViewEditSitePage',
  VIEW_LIST_SITES_PAGE = 'ViewListSitesPage',
}
